<template>
  <div
    v-if="!renderAwait"
    class="board-card item-card"
    :class="{ 'board-card--highlighted': item.highlighted }"
    @click="handleCardClick"
  >
    <content-line
      outlined
      class="board-card__main"
      :text="item.title"
      :selectedText="item.text"
      :tooltip="showTooltip"
    >
      <template #actions v-if="controls.length">
        <v-menu
          offsetY
          :offsetX="false"
          left
          content-class="dropdown-menu dropdown-menu--dark"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              class="dropdown-menu__button"
              fab
              small
              icon
              v-on="on"
              color="appMain"
              @click.native="handleNavClick"
            >
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              v-for="(control, idx) in controls"
              :key="idx"
              @click="fireAction(control, item)"
              color="light"
            >
              <v-list-item-title>
                {{ control.title }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </content-line>

    <div
      v-if="item.assigned_to && item.assigned_to.length"
      class="board-card__assigned"
    >
      <user-info-circle
        v-for="userId in item.assigned_to"
        :key="userId"
        :userId="userId"
      />
    </div>
  </div>
</template>

<script>
import UserInfoCircle from '@/views/contacts/contact/UserInfoCircle';
import { isTextOverflow } from '@/filters/helpers';

export default {
  name: 'BoardCard',
  components: {
    UserInfoCircle,
  },
  data() {
    return {
      showTooltip: false,
    };
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    controls: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    async checkTooltip() {
      await this.$nextTick();
      const el = this.$el.querySelector('.content-line__text-main');
      this.showTooltip = isTextOverflow(el);
    },
    handleCardClick(e) {
      if (!e.metaKey && !e.ctrlKey) {
        this.$emit('editItem');
      }
    },
    fireAction(control, item) {
      if (typeof control.action !== 'function') {
        console.log('No action defined for control', control);
      }
      control.action(item);
    },
    handleNavClick() {
      this.$emit('toggleItemSelection');
    },
  },
  mounted() {
    this.checkTooltip();
  },
};
</script>
